import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconPropsAll } from 'common/icon/icon.js';
import { ListInlineItemMockProps, ListInlineValueMock } from './list-inline-value.js';

export type ListInlineIconProps = IconPropsAll & {
  title: string;
} & ListInlineItemMockProps;

/** Wrap with className="grid-list" */
export const ListInlineIconItem = (props: ListInlineIconProps) => {
  return (
    <IconWithText {...props} classes="IconWithText--vCenter IconWithText--small">
      <ListInlineItem lineBreak={props.lineBreak} title={props.title}>
        {props.children}
      </ListInlineItem>
    </IconWithText>
  );
};

export const ListInlineItem = ({
  title,
  classes,
  ...props
}: ListInlineItemMockProps & { title: string; classes?: string }) => {
  return (
    <div className={classNames('u-mT-0 u-mB-0 u-flex u-flexJustifyBetween u-flexAlignItemsCenter', classes)}>
      <span className={classNames('grid-list-text u-flexGrow-0 u-text-sm')}>{title}</span>
      <ListInlineValueMock {...props} />
    </div>
  );
};
